import { CredentialReviewStatus } from '@paladin-monorepo/common';

export type CredentialItemStatusKey = 'draft' | 'pending' | 'approved' | 'rejected';

export function credentialItemStatusKey(
  reviewStatus: string,
  isReplacement: boolean,
): CredentialItemStatusKey {
  if (isReplacement && reviewStatus === CredentialReviewStatus.Pending) {
    return 'draft';
  }
  if (reviewStatus === CredentialReviewStatus.Approved) return 'approved';
  if (reviewStatus === CredentialReviewStatus.Rejected) return 'rejected';
  return 'pending';
}

export function credentialStatusBadgeVariant(
  status: CredentialItemStatusKey,
): 'default' | 'secondary' | 'destructive' | 'outline' {
  if (status === 'approved') return 'default';
  if (status === 'rejected') return 'destructive';
  if (status === 'draft') return 'outline';
  return 'secondary';
}
